var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_927_904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_927_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25119 32.583L11.9753 30.958C11.6682 29.986 11.393 29 11.1498 28C10.9065 27 10.7081 25.986 10.5546 24.958L8.25119 26.667V32.583ZM14.5477 30.542H21.3805C21.9179 29.0973 22.3338 27.5627 22.628 25.938C22.9228 24.3127 23.0702 22.8193 23.0702 21.458C23.0702 18.4027 22.648 15.6597 21.8034 13.229C20.9588 10.7983 19.6791 8.63867 17.9641 6.75001C16.2492 8.63867 14.9694 10.7983 14.1248 13.229C13.2802 15.6597 12.858 18.4027 12.858 21.458C12.858 22.8193 13.0054 24.3127 13.3002 25.938C13.5944 27.5627 14.0103 29.0973 14.5477 30.542ZM17.9641 21.375C17.1963 21.375 16.5372 21.0763 15.9869 20.479C15.4365 19.8817 15.1613 19.1663 15.1613 18.333C15.1613 17.4997 15.4365 16.7847 15.9869 16.188C16.5372 15.5907 17.1963 15.292 17.9641 15.292C18.7319 15.292 19.391 15.5907 19.9413 16.188C20.4917 16.7847 20.7669 17.4997 20.7669 18.333C20.7669 19.1663 20.4917 19.8817 19.9413 20.479C19.391 21.0763 18.7319 21.375 17.9641 21.375ZM27.677 32.583V26.667L25.3736 24.958C25.2201 25.986 25.0217 27 24.7784 28C24.5352 29 24.26 29.986 23.9529 30.958L27.677 32.583ZM17.9641 3.08301C20.5488 5.41634 22.4747 8.11101 23.7419 11.167C25.0085 14.2223 25.6417 17.7223 25.6417 21.667V21.792L29.0968 24.333C29.4555 24.583 29.7372 24.9093 29.9417 25.312C30.1462 25.7153 30.2485 26.153 30.2485 26.625V36.667L22.5709 33.333H13.3573L5.67969 36.667V26.625C5.67969 26.153 5.78196 25.7153 5.9865 25.312C6.19104 24.9093 6.47267 24.583 6.83138 24.333L10.2865 21.792V21.667C10.2865 17.7223 10.9197 14.2223 12.1863 11.167C13.4535 8.11101 15.3794 5.41634 17.9641 3.08301Z",
    fill: "#2B74E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.01087bfc66819c5daf31f65b770dcfed.svg";
export { ForwardRef as ReactComponent };